<template>
  <div class="custom-about-page">

    <div class="banner top-banner">
      <div class="banner-desc">
        <div class="title">{{ $t('custom_intro.banner_title') }}</div>
        <div class="sub-title">{{ $t('custom_intro.banner_subtitle') }}</div>
      </div>
      <!-- <picture>
        <img :src="introtData.photo">
      </picture> -->
      <Banner loc="4" :baseBtn="false"/>
    </div>  

    <CaptionBar :title="$t('custom_intro.caption_bar')" subTitle="CUSTOMIZE" />

    <div class="content c-layout">
      <div class="content-title">{{ introtData.title }}</div>
      <div class="content-words">
        <!-- 近年吹起無鋼圈內衣的流行，少了鋼圈的壓迫感，穿上無鋼圈的舒適自在感讓眾多少女們念念不忘，但又害怕 習慣穿無鋼圈會讓胸部外擴、副乳的問題變得嚴重。<br>不過這邊要告訴大家：內衣的設計生產技術已經很進步，即使少了鋼圈，內衣仍然可以透過加強其他的結構來 增加機能性，而且現在無鋼圈內衣款式越來越多，素面無痕的、可愛的、性感的通通有～想要舒適又有機能的 無鋼圈內衣推薦款，看這篇就對了！<br><br>※ 特別推薦：Huwa無鋼圈內衣<br><br>這篇要推薦的無鋼圈內衣分成四種類型！女孩們可依照妳們的需求挑選唷！<br><br>素面無痕百搭款：上班襯衫、出遊洋裝都可以穿！<br>蕾絲美背款：小露心機、夏季穿搭不二人選！<br>下厚上薄爆乳款：小胸救星～打造深v事業線！<br>蕾絲薄襯款：性感蕾絲薄襯，隱藏的迷人誘惑！<br>以下來分別介紹四種類型的無鋼圈內衣吧！ -->
        {{ introtData.content }}
      </div>
    </div>

    <div class="banner">
      <picture>
        <!-- <source srcset="./images/banner2-mob.png" media="(max-width: 992px)"> -->
        <!-- <img src="./images/banner2.png"> -->
        <img :src="introtData.photo">
      </picture>
    </div>  

    <div class="content2 c-layout">
      <div class="content-left">
        <div class="content-title hide-on-pad">{{ introtData.title2 }}</div>
        <div class="content-title show-on-pad">{{ introtData.title2 }}</div>
        <div class="content-words">
          <!-- 分別是<br>素面無痕百搭款：上班襯衫、出遊洋裝都可以穿！<br>蕾絲美背款：小露心機、夏季穿搭不二人選！<br>跟上次開箱的感覺一樣，放在手中細緻的觸感，完全感受到亞曼菲對內衣品 質的堅持。畢竟內衣是最貼近身體的私密衣物，小娜真心建議大家還是要選 擇舒適、質感好點的!跟上次開箱的感覺一樣，放在手中細緻的觸感，完全感 受到亞曼菲對內衣品質的堅持。畢竟內衣是最貼近身體的私密衣物，小娜真 心建議大家還是要選擇舒適、質感好點的! -->
          {{ introtData.content2 }}
        </div>
      </div>
      <div class="content-img">
        <picture>
          <!-- <source srcset="./images/detail-mob.png" media="(max-width: 992px)">
          <img src="./images/detail.png" alt=""> -->
          <img :src="introtData.photo2">
        </picture>
      </div>
    </div>
    <div class="btn btn-orange toForm" @click="handelToCustom">{{ $t('btns.goto_custom') }}</div>

  </div>
</template>

<script>
import Banner from "@/components/Banner";
import CaptionBar from "@/components/CaptionBar";
import { getCustomIntro }  from '../../api'

  export default {
    name: 'custom-about',
    data() {
      return {
        introtData: {}
      }
    },
    components: {
      CaptionBar,Banner
    },
    async created() {
      const { data } = await getCustomIntro();
      console.log('introtData',data);
      this.introtData = data[0]
    },
    methods: {
      handelToCustom() {
        this.$router.push({ name: 'customForm' });
      },
    }
  }
</script>

<style lang="less" scoped>
.custom-about-page {
  overflow: hidden;
  .banner {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .banner-desc {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      color: white;
      background: rgba(255,255,255,.2);
      // padding: 6rem 10rem;
      text-align: center;
      word-break: keep-all;
      height: 60%;
      width: 620px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 10;
      .title {
        font-size: 5.5rem;
        font-weight: 400;
        margin-bottom: 10px;
      }
      .sub-title {
        font-size: 4.5rem;
        font-weight: 300;
      }
    }
    @media (max-width: 992px) {
      .banner-desc {
        // top: unset;
        bottom: 60px;
        transform: translate(-50%,-50%);
        // padding: 5rem 1rem;
        width: 85%;
        .title {
          font-size: 3rem;
        }
        .sub-title {
          font-size: 2rem;
        }
        &::after {
          content: '';
          position: absolute;
          width: calc(100% + 20px);
          height: calc(100% + 10px);
          top: -5px;
          left: -10px;
          border: 1px solid white;
        }
      }
    }
  }

  /deep/ .caption-bar-comp {
    transform: translateY(-25px);
    &.flow-title {
      transform: translateY(0);
    }
    @media (max-width: 992px) {
      transform: translateY(-15px);
      &.flow-title {
        transform: translateY(0);
      }
    }
    .caption-line {
      width: 100%;
    }
  }

  .content {
    padding: 0 15px;
    margin-bottom: 2rem;
    .content-title {
      color: #FF5214;
      font-size: 2rem;
      font-weight: 500;
      text-align: center;
      margin: 20px 0 40px 0;
    }
    .content-words {
      line-height: 1.5rem;

      text-align: center;
    }
    @media (max-width: 992px) {
      .content-title {
        margin: 0px 0 20px 0;
      }
    }
  }
  
  .content2 {
    display: flex;
    margin: 40px auto;
    padding: 0 15px;
    margin-bottom: 50px;
    .content-left {
      flex: 1;
    }
    .content-title {
      color: #FF5214;
      font-size: 1.5rem;
      font-weight: 400;
      margin: 20px 0 40px 0;
    }
    .content-words {
      line-height: 1.5rem;
    }
    .content-img {
      flex: 1;
      margin-left: 20px;
      img {
        display: block;
        width: 100%;
      }
    }
    @media (max-width: 992px) {
      flex-direction: column;
      margin-top: 10px;
      .content-left {
        margin-bottom: 10px;
      }
      .content-title {
        margin: 0px 0 10px 0;
        line-height: 2rem;
      }
      .content-img {
        margin-left: -15px;
        margin-bottom: 10px;
        margin-right: -15px;
      }
    }
  }
  .toForm {
    width: 150px;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 30px;
    @media (max-width: 992px) {
      position: fixed;
      margin-bottom: 0;
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 1;
    }
  }

}
</style>